<template>
  <div v-cloak v-if="writer!=null">
    <van-cell style="background-color: #1aad19">
        <van-row  type="flex" justify="start" align="ceter">
          <van-col span="5">
            <writer-avatar shape="circle" :size="48" :writer="writer"></writer-avatar>
<!--            <div class="avatar-wrap"><van-image style="padding: 2px;background-color: #fff" round scale-down lazy-load :src="writer.avatar.web_path"></van-image></div>-->
          </van-col>
          <van-col span="14" >
            <div class="row-conent">
              <div class="writer-nickname-white">{{writer.writer_name}}</div>
              <div class="writer-labels">
                <span  v-for="(item, index) in writer.labels" :key="index" class="writer-label-white">{{item.text}}</span>
              </div>
            </div>
          </van-col>
          <van-col span="5">
            <div class="writer-subscript-btn">
              <van-button   class="subscript-white" v-if="writer.is_subscript"   round plain size="small" @click.stop="unsubscript(writer.writer_id)">
                取关
              </van-button>
              <van-button  class="subscript-white" v-else  round plain  size="small"  @click.stop="subscript(writer.writer_id)">
                关注
              </van-button>
            </div>
          </van-col>
        </van-row>
    </van-cell>
    <div class="article-wrap-title van-hairline--bottom">Ta的发布</div>
    <van-pull-refresh v-model="is_refresh" @refresh="onRefresh">
      <van-list v-model="is_loading"
                :finished="is_load_finished"
                :immediate-check="false"
                finished-text="没有更多了"
                :error.sync="is_error"
                error-text="请求失败，点击重新加载"
                @load="onLoad">
        <van-cell v-for="(item, index) in list" :key="item.project_id" v-on:click="go_detail(item.project_id)">
            <div class="weball-font-14 weball-font-color-maintext van-ellipsis" style="width:100%">{{item.project_title}}</div>
            <van-row gutter="5" justify="start" align="ceter">
                <van-col>
                    <text-icon :color="'#888'" :text="item.project_price | price" :icon="'balance-o'" :textSize="14" :iconSize="14"></text-icon>
                </van-col>
                <van-col style="margin-left: 10px">
                    <van-icon v-if="count<6" v-for="count in Math.ceil(item.project_borwser_num/100)" color="#C8C8C8" name="fire" size="14"></van-icon>
                </van-col>
            </van-row>
            <van-row class="author-project-list" gutter="5" v-for="(item, index) in item.articles" :key="item.article.article_id" >
                <van-col class="weball-font-14 van-ellipsis" span="21" style="text-align: left">{{item.article.article_content_visible}}</van-col>
                <van-col span="3" style="text-align: right;display: flex;flex-direction: row;align-items: center;justify-content: flex-end">
                    <van-image v-if="item.article.article_result===1"  contain lazy-load :src="images.article_status_red"></van-image>
                    <van-image v-else-if="item.article.article_result===2"  scale-down lazy-load :src="images.article_status_go"></van-image>
                    <van-image v-else-if="item.article.article_result===3"  scale-down lazy-load :src="images.article_status_black"></van-image>
                </van-col>
            </van-row>

        </van-cell>

      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
    import article_status_black from '@/assets/article_status_black.png'
    import article_status_go from '@/assets/article_status_go.png'
    import article_status_red from '@/assets/article_status_red.png'
    import game_over from '@/assets/game_over.png'
    import WriterAvatar from "@/views/components/WriterAvatar";
    import TextIcon from '@/components/TextIcon'
    export default {
        name:"authordetail",
        components: {
            TextIcon,
            WriterAvatar
        },
        filters:{
            price($value){
                if($value<=0)
                    return '免费'
                else
                    return  $value
            }
        },
        data() {
            return {

                images:{
                    article_status_black:article_status_black,
                    article_status_go:article_status_go,
                    article_status_red:article_status_red,
                    game_over:game_over
                },
                writer_id: this.$route.params.writer_id,
                writer:null,
                page: 0,
                list: [],
                is_error: false,
                is_refresh: false,
                is_loading: false,
                is_load_finished: false
            }
        },
        created(){

            this.getData(this.writer_id);
            this.page = 1;
            this.getList(this.page, false)
        },
        mounted() {
        },

        methods:{
            onRefresh() {
                this.page = 1;
                this.is_load_finished = false;
                this.getList(this.page, true)
            },
            onLoad() {
                this.page++;
                this.getList(this.page, false);

            },
            getList: function (page, refresh) {
                let that = this;
                this.weapi.request({
                    url: 'writer_projects',
                    method: 'get',
                    params: {page:page, writer_id:this.writer_id, platform:'web'},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.list = [];
                            that.$toast('刷新成功！');
                            that.is_refresh = false;
                        }
                        if (that.page <= 1) {
                            that.list = [];
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.is_load_finished = true;
                        }
                    }
                    else {
                        that.is_refresh = false;
                        that.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.is_refresh = false;
                    that.is_error = true;
                }).finally(function (response) {
                    that.is_loading = false;
                })
            },
            getData: function (writer_id) {
                let that = this;
                this.weapi.request({
                    url: 'writer_detail',
                    method: 'get',
                    params: {'writer_id':writer_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.writer = res.data.data;
                    }
                    else {
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            subscript:function(writer_id){
                if(!this.westore.getters.logined){
                    this.$router.push({ name: this.werouter.login.name})
                }
                let that = this;
                this.weapi.request({
                    url: 'writer_subscript',
                    method: 'post',
                    params: {writer_id:writer_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.writer.is_subscript = res.data.data.is_subscript;
                        that.eventbus.$emit(that.weconfig.event.subscriptChanged, that.writer.is_subscript);
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            unsubscript:function(writer_id){
                if(!this.westore.getters.logined){
                    this.$router.push({ name: this.werouter.login.name})
                }
                let that = this;
                this.weapi.request({
                    url: 'writer_unsubscript',
                    method: 'post',
                    params: {writer_id:writer_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.writer.is_subscript = res.data.data.is_subscript;
                        that.eventbus.$emit(that.weconfig.event.subscriptChanged, that.writer.is_subscript);
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            go_detail: function (ID) {

                this.$router.push({ name: this.werouter.project.name, params: { project_id: ID}})
            }
        }
    }

</script>
<style>
  .writer-subscript-btn{
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content:flex-end;
    align-items: center;
  }
  .writer-labels{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

  }
  .writer-nickname-white{
    font-size: 16px;
    color: #fff;
  }
  .writer-labels .writer-label-white{
    font-size: 12px;
    border: 1px solid #fff;
    color: #fff;
    padding: 2px 8px;
    border-radius: 0 32px 32px 32px;
    line-height: 18px;
    margin-top: 5px;
    margin-right:10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    max-width: calc(14px * 6);
  }
  .subscript-white{
    width:64px;
    height: 24px;
    line-height: 24px;
    background-color: #1aad19;
    color: #fff;
    border-color: #fff;
    font-size: 12px;
    padding: 0;
  }
  .article-wrap-title{
    text-align: center;
    font-weight: 600;
    color: #333;
    font-size: 16px;
    padding: 15px 10px 10px 10px;
  }
  .no-article{
    font-size: 18px;
    color: #888;
    text-align: center;
    padding: 30px;
  }
  .author-project-list{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 5px 0;
    padding: 5px 5px;
    font-size: 12px;
    color: #888;
    background-color: #f5f6f8;
  }
  .article-status-image{
    position: absolute;
    right: 10px;
    top: 10px;
  }
</style>
